const clickOutside = (
  selector: string, action: () => void
) => (
  event: React.SyntheticEvent<MouseEvent>
) => {
  const insideElement = document.querySelector(selector);
  if (insideElement && !insideElement.contains(event.target as Node)) {
    action();
  }
};

export default clickOutside;
